import { Alert, Box, Button } from '@mui/material';
import { useContext } from 'react';
import { BudgetMonthContext } from './BudgetMonthContextProvider';

const BudgetMonthEditingAlert = () => {
  const { setIsEditing, onSaveBudgetMonth } = useContext(BudgetMonthContext);

  const handleDiscardEditing = () => {
    setIsEditing(false);
  };

  return (
    <Alert
      severity="info"
      action={
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button
            color="inherit"
            size="small"
            variant="outlined"
            onClick={onSaveBudgetMonth}
          >
            Save
          </Button>
          <Button
            color="error"
            size="small"
            variant="outlined"
            onClick={handleDiscardEditing}
          >
            Discard
          </Button>
        </Box>
      }
      sx={{ mb: 2 }}
    >
      Editing mode, setup your budgets for this month.
    </Alert>
  );
};

export default BudgetMonthEditingAlert;
